var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"login"},[_c('div',{staticClass:"login__logo"}),_c('LoginBg'),_c('div',{staticClass:"login__box"},[_vm._v("Verifying your registration...")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }